
























































































import Vue from 'vue';

import { MDCTextField } from '@material/textfield';
import { MDCSnackbar } from '@material/snackbar';

import Axios from 'axios';

interface Data {
  newAddress: string;
  inputsMDC: MDCTextField[];

  waitForResponse: boolean;
  confCode: string;

  successSnackbar: MDCSnackbar;
  failSnackbar: MDCSnackbar;
}

export default Vue.extend({
  data(): Data {
    return {
      newAddress: window.localStorage.getItem('login'),
      waitForResponse: false,
      inputsMDC: [],
      confCode: '',
      successSnackbar: {} as MDCSnackbar,
      failSnackbar: {} as MDCSnackbar,
    } as Data;
  },
  mounted() {
    const textFields = this.$el.querySelectorAll('.mdc-text-field') as NodeListOf<HTMLInputElement>;
    for (const textField of textFields) {
      this.inputsMDC.push(new MDCTextField(textField));
    }
    this.successSnackbar = new MDCSnackbar(this.$el.querySelector('.mdc-snackbar.success') as HTMLElement);
    this.failSnackbar = new MDCSnackbar(this.$el.querySelector('.mdc-snackbar.fail') as HTMLElement);
  },
  beforeDestroy() {
    for (const textField of this.inputsMDC) {
      textField.destroy();
    }
    this.successSnackbar.destroy();
    this.failSnackbar.destroy();
  },
  methods: {
    preventSubmit(ev: Event) {
      ev.preventDefault();
    },
    sendMail() {
      Axios.post('/API/user/updateEmail', { Address: this.newAddress })
        .then(() => {
          this.waitForResponse = true;
          (this.$el.querySelector('.waiting input') as HTMLInputElement).focus();
        });
      // .catch(() => this.failSnackbar.open());
    },
    sendConf() {
      console.log('conf', this.confCode);
      Axios.put('/API/user/updateEmail', { Code: this.confCode })
        .then(() => {
          console.log('OK');
          this.successSnackbar.open();
          this.waitForResponse = false;
        })
        .catch(() => this.failSnackbar.open());
    },
  },
});
